<template>
  <v-app>
    <v-app-bar
      app
      light
      height="45"
    >
      <v-spacer></v-spacer>
      <LanguagePanel />
    </v-app-bar>
    <v-main class="simple-layout">
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <v-col>
            <v-img
              alt="Logo"
              contain
              class="shrink"
              :src="require(`../assets/logo_color.png`)"
              width="160"
              height="40"
              style="margin:0 auto 20px auto"
            />
            <v-card
              class="mx-auto"
              max-width="500"
            >
              <v-card-title class="d-block text-center">{{ pageTitle }}</v-card-title>
              <v-card-text>
                <slot />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import intl from '@/utils/intl';
import LanguagePanel from '@/components/language-panel.vue';

export default Vue.extend({
  props: {
    title: String
  },
  components: {
    LanguagePanel
  },
  computed: {
    pageTitle() {
      return intl.t(this.title);
    }
  }
});
</script>

<style lang="scss" scoped>
.v-app-bar {
  user-select: none;

  &.v-toolbar {
    box-shadow: none !important;
    background-color: transparent !important;
  }
}
.simple-layout {
  background-color: $layout-bg;
}
</style>
